import { render } from "./UnauthorizedView.vue?vue&type=template&id=40041bff&scoped=true"
import script from "./UnauthorizedView.vue?vue&type=script&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&lang=js"

import "./UnauthorizedView.vue?vue&type=style&index=0&id=40041bff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40041bff"]])

export default __exports__